<template>
  <FormContainer withoutDivider>
    <template #title>Informations du module</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id=""
          label="Intitulé du module"
          :modelValue="module?.intitule"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
        <WrapperDropdown
          id=""
          class="col-9 col-md-18 col-sm-36"
          label="Type de module"
          :modelValue="0"
          :items="[{ id: 0, label: module?.typeModule }]"
          :disabled="true"
        />
        <WrapperInput
          id=""
          label="Prestataire"
          :modelValue="module?.etablissementPrestataire?.denomination"
          class="col-9 col-md-18 col-sm-36"
          :disabled="true"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id=""
          label="Date de début du module"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :modelValue="module?.dateDebut"
          :disabled="true"
        />
        <WrapperInputDate
          id=""
          label="Date de fin du module"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :modelValue="module?.dateFin"
          :disabled="true"
        />
        <WrapperInput
          id=""
          label="Durée du module"
          class="col-9 col-md-18 col-sm-36"
          :modelValue="module?.duree + 'h'"
          :disabled="true"
        />
        <BasicButton
          class="col-9 col-md-18 col-sm-36"
          :disabled="moduleReadonly"
          @click="showPropagateModal = true"
          label="Définir présences stagiaires"
        />
      </div>
    </template>
  </FormContainer>
  <Teleport to="main">
    <ModalComponent v-model="showPropagateModal">
      <template #header>Appliquer les informations</template>
      <template #content>
        <BasicText
          color="neutral-500"
          size="body-l"
        >
          Voulez-vous appliquer les informations du module (dates, durée) à toutes les présences stagiaires ?
        </BasicText>
      </template>
      <template #actions>
        <div class="flex flex-gap-4">
          <BasicButton
            label="Annuler"
            size="medium"
            class="flex-1"
            @click="showPropagateModal = false"
          />
          <BasicButton
            label="Appliquer"
            type="secondary"
            size="medium"
            class="flex-1"
            @click="propagateData"
          />
        </div>
      </template>
    </ModalComponent>
  </Teleport>
</template>

<script setup lang="ts">
  import FormContainer from '@/features/interface/demande/shared/components/FormContainer.vue'
  import { DEMANDE_STORE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { inject, ref } from 'vue'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
  import type { AttestationDTO } from '@/features/api/extranet/dto/Demande/DR'
  import { useModuleAttestations } from '@/features/interface/demande/dr/steps/modules/useModuleAttestations.ts'

  const props = defineProps<{
    moduleIndex: number
  }>()

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_DR')
  const { setupCustomUpdater } = store

  const state = useModuleAttestations(props.moduleIndex)
  const { module, moduleReadonly } = state

  const showPropagateModal = ref(false)

  const propagateData = setupCustomUpdater<AttestationDTO | null>((patch) => {
    patch.attestations
      .filter((attestation) => {
        return attestation.idModule === module.value?.idModule
      })
      .forEach((elem) => {
        elem.dateDebut = module.value?.dateDebut
        elem.dateFin = module.value?.dateFin
        elem.duree = module.value?.duree
      })
    showPropagateModal.value = false
  })
</script>
